import React from "react";
import { get } from "lodash";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import queryString from "query-string";
import { createFetch } from "../../utils";
import { bindActionCreators } from "redux";
import { registerLoginInfo } from "./actions";
import {
  Grid,
  Typography,
  Input,
  InputLabel,
  FormControl,
  Box,
} from "@mui/material";
import LoginBackground from "../../static/img/login-background.png";
import "./styles.scss";
import WakatobiLogo from "../../static/img/wakatobi-logo-1.svg";
import ErrorModal from "./Components/errorModal";
import LanguageSwitcher from "../../components/languageSwitcher";
import LanguageOverlay from "../../components/languageOverlay";
import VerificationCodeModal from "./Components/verificationCodeModal";
import { withTranslation } from "react-i18next";

const { URL_PREFIX } = window;

class VF2Login extends React.Component {
  constructor() {
    super();
    const url = new URL(window.location.href);
    const soNum = url.searchParams.get("sonum") || "";
    const guest = url.searchParams.get("guest") || "";
    const passCode = url.searchParams.get("sopassCode") || "";
    this.state = {
      errorMessage: null,
      showErrorModal: false,
      showVerifModal: false,
      errorMessageVerif: '',
      showErrorVerif: false,
      showLanguageOverlay: true,
      form: {
        soNum,
        guest,
        passCode,
      },
      resultForm: {},
      loading: false,
      loadingVerif: false,
    };
    this.login = this.login.bind(this);
    document.title = "Wakatobi - Visit Form 2";
  }

  changeForm(key, value) {
    const { form } = this.state;
    form[key] = value;
    this.setState({ form });
  }

  componentWillMount() {
    let params = queryString.parse(this.props.location.search);
    this.setState({
      form: {
        soNum: get(params, "sonum", ""),
        guest: get(params, "guest", ""),
        passCode: get(params, "sopasscode", ""),
      },
    });
  }

  async login(e) {
    e.preventDefault();
    this.setState({ loading: true, errorMessage: null, showErrorModal: false });

    try {
      const { soNum, guest, passCode } = this.state.form;

      const result = await createFetch({
        path: "vf2/login",
        method: "POST",
        accessToken: null,
        body: {
          soNumber: soNum,
          email: guest,
          passcode: passCode,
        },
      });
      
      if (result.status === 200) {
        this.setState({resultForm: result, showVerifModal:true})
      }
    } catch (error) {
      let errorMessage = this.props.t("An unknown error occurred");
      if (error.response) {
        errorMessage = error.response.message || "Login failed"; // Server error
      } else if (error.message) {
        errorMessage = error.message; // Client-side or network error
      }
      this.setState({
        errorMessage,
        showErrorModal: true, // Trigger ErrorModal on failure
      });
    } finally {
      this.setState({ loading: false });
    }
  }

  async onVerif(code){
    try {
      this.setState({ loadingVerif: true });
      if (code.length === 0) throw new Error(this.props.t('Please enter the complete verification code!'))
      const {resultForm} = this.state

      const urlVerif = resultForm.isLoginAsSalesAgent ? 
        `vf2/so/authcode/${resultForm.soId}` : 
        `vf2/guest/authcode/${resultForm.guestId}`

      const result = await createFetch({
        path: urlVerif,
        method: "POST",
        accessToken: resultForm.token.token,
        body: {
          "Authentication_Code__c" : code
        }
      });

      if (result.status === 200) {
        this.setState({showVerifModal: false})
        this.props.registerLoginInfo({
          token: resultForm.token.token,
          expired: resultForm.token.expired,
          soId: resultForm.soId,
          guestId: resultForm.guestId,
          mainGuest: resultForm.MainApplicant,
          isLoginAsSalesAgent: resultForm.isLoginAsSalesAgent
        });
        this.props.history.push(`${URL_PREFIX}/vf2/wizard`);
      }
        
    } catch (error) {
      let errorMessage = this.props.t("An unknown error occurred");
      if (error.response) {
        errorMessage = error.response.message || "Login failed"; // Server error
      } else if (error.message) {
        errorMessage = error.message; // Client-side or network error
      }
      this.setState({
        errorMessageVerif: errorMessage,
        showErrorVerif: true, // Trigger ErrorModal on failure
      });
    }finally{
      this.setState({ loadingVerif: false });
    }
  }

  async onResend(){
    try {
      const {resultForm} = this.state
      const urlVerif = resultForm.isLoginAsSalesAgent ? 
        `vf2/so/authcode/${resultForm.soId}` : 
        `vf2/guest/authcode/${resultForm.guestId}`
      await createFetch({
        path: urlVerif,
        method: "PATCH",
        accessToken: resultForm.token.token,
      });
    } catch (error) {
      
    }
  }

  render() {
    const { errorMessage, form, loading, showErrorModal, showVerifModal, showLanguageOverlay } = this.state;
    return (
      <div className="wrapper with-background">
        {showErrorModal && (
          <ErrorModal
            isOpen={showErrorModal}
            handleClose={() => this.setState({ showErrorModal: false })}
            errorMessage={errorMessage}
          />
        )}
        {showVerifModal && (
          <VerificationCodeModal
            isOpen={showVerifModal}
            handleClose={() => this.setState({ showVerifModal: false })}
            onConfirm={(code) => this.onVerif(code)}
            error={this.state.showErrorVerif}
            errorMessage={this.state.errorMessageVerif}
            isLoading={this.state.loadingVerif}
            onResend={this.onResend}
          />
        )}

        <LanguageOverlay
          open={showLanguageOverlay}
          onClose={() => this.setState({showLanguageOverlay: false})}
        />

        <Grid container rowSpacing={1}>
          <Grid item md={6} sm={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                height: 60,
                marginTop: "67px",
              }}
            >
              <img src={WakatobiLogo} alt="Logo visit" />
            </Box>
            <div
              className="login-box"
              style={{ display: "flex", justifyContent: "center" }}
            >
              

              <div className="account-wall">
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    sx={{
                      color: "#101828",
                      fontWeight: 600,
                      marginBottom: "20px",
                    }}
                  >
                    {this.props.t("Login to your visit form")}
                  </Typography>
                  <Typography variant="text-large" sx={{ color: "#667085" }}>
                    {this.props.t("Please enter your details according to the email you have received")}
                  </Typography>
                </div>

                <div style={{ marginTop: "20px" }}>
                  <form className="form-signin">
                    <input type="hidden" name="_token" value="" />
                    <input type="hidden" name="so_num" value={form.soNum} />
                    <FormControl>
                      <InputLabel>
                        {this.props.t("Email / Guest ID")}
                      </InputLabel>
                      <Input
                        type="text"
                        placeholder={this.props.t("Email / Guest ID")}
                        name={`so_email_${Math.random()}`} // Add randomness to the name
                        autoComplete="new-password"
                        value={form.guest}
                        required
                        onChange={(e) =>
                          this.changeForm("guest", e.target.value)
                        }
                      />
                    </FormControl>
                    <FormControl>
                      <InputLabel>{this.props.t("Passcode")}</InputLabel>
                      <Input
                        type="password"
                        placeholder={this.props.t("Passcode")}
                        autoComplete="new-password"
                        name={`so_passcode_${Math.random()}`} // Add randomness to the name
                        value={form.passCode}
                        required
                        onChange={(e) =>
                          this.changeForm("passCode", e.target.value)
                        }
                      />
                    </FormControl>
                    <button
                      disabled={loading}
                      className="btn btn-lg btn-primary btn-block"
                      style={{
                        width: "412px",
                        marginTop: "30px",
                        height: "auto",
                        background: "#66C7D1",
                        color: "black",
                        fontWeight: 600,
                        fontSize: "16px",
                        border: "1px solid #66C7D1",
                      }}
                      type="submit"
                      onClick={this.login}
                    >
                      {loading ? (
                        <i className="fa fa-circle-notch fa-spin fa-2x loading" style={{ fontSize: '16px' }} />
                      ) : null}
                      <i className="fa fa-sign-in" />{this.props.t("Login")}
                    </button>
                  </form>
                </div>

                
              </div>
            </div>

            <div
              className="login-box"
              style={{ display: "flex", justifyContent: "center", marginTop: '15px' }}
            >
              <div className="account-wall" style={{marginTop: 0, padding: '0'}}>
                <LanguageSwitcher style={{width:'100%'}} />
              </div>
            </div>

          </Grid>
          <Grid item md={6} sm={12}>
            <img
              src={LoginBackground}
              alt="login-background"
              style={{ width: "100%", height: "100vh" }}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

VF2Login.propTypes = {
  registerLoginInfo: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      registerLoginInfo,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  vf2: state.vf2,
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VF2Login));